import { get } from "../../api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const loadGlobalRights = () => get(`${url}/parameters/global-rights`);

const exp = {
  loadGlobalRights
};
export default exp;
